import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FormattedMessage, useIntl} from "react-intl";
import {IState} from "../../../types/state";
import {url} from "../../../helper";
import {getUpOrCrossProd} from "../../../store/cart";
import {AddCartToken} from "../../../store/token";
import {wishlistRemoveItem} from "../../../store/wishlist";
import Head from "next/head";
import {CheckToastSvg,} from "../../../svg";
import {setPopupName, setWindowSize} from "../../../store/general";
import dynamic from 'next/dynamic'
import {useToast} from "../../../atoms/Toast/useToast";
import {checkDetail, replaceDescr} from "../../../services/utils";
import {ISkuOption} from "../../../types/homePageTypes";
import cls from "./product.module.scss"
import BuilderSection from "../../builder/BuilderDataRender";
import Link from "next/link";


// @ts-ignore
const AsyncAction = dynamic(() => import('.././AsyncAction'))
const InputNumber = dynamic(() => import('../InputNumber'))
const ProductGallery = dynamic(() => import('../ProductGallery'))
const SMSharedButton = dynamic(() => import('../SMSharedButton'))
const Prices = dynamic(() => import('../Prices'))
const WishIcon = dynamic(() => import('../WishIcon'))
const Details = dynamic(() => import('./Details'))

const SimpleProduct = (props: any) => {
    const token = useSelector((state: IState) => state.cartToken);
    const customer = useSelector((state: IState) => state.customer);
    const bOrder = useSelector((state: IState) => state.general.Backorders);
    const signed = useSelector((state: IState) => state.customer.authenticated);
    const wishlist = useSelector((state: IState) => state.wishlist);
    const backorders = useSelector((state: IState) => state.general.Backorders);
    const currencyCode = useSelector((state: IState) => state.rate.current.code);
    const rate = useSelector((state: IState) => state.rate.exchange_rate.rate);
    const phone = useSelector((state: IState) => state.general.coreConfigs.general_info_general_phone?.value);
    const general_info_general_phone = useSelector((state: IState) => state.general.coreConfigs.general_info_general_phone);
    const dispatch = useDispatch();
    const toast = useToast();
    const [product, setProduct] = useState(props.productData)
    const [isSelectDetail, setIsSelectDetail] = useState(false)
    const details = props.productData.details
    let checkAddProd = false;
    const [isMobile, setIsMobile] = useState(false)
    let windowSize = useSelector((state: IState) => state.general.windowSize)
    const intl = useIntl();
    const [phoneNumber, setPhoneNumber] = useState("")
    // const [hasPhoneNumber, setHasPhoneNumber] = useState(false)

    useEffect(() => {
        if (!windowSize) dispatch(setWindowSize(window.innerWidth))
        setIsMobile(windowSize <= 576)
    }, [windowSize])

    useEffect(() => {
        setPhoneNumber(phone)
    }, [phone]);

    // useEffect(() => {
    //     if(props.translations.hasOwnProperty("phone_number_service_theme")){
    //         setHasPhoneNumber(true)
    //         setPhoneNumber(intl.formatMessage({id: 'phone_number_service_theme'}))
    //     }else setHasPhoneNumber(false)
    // }, [])

    const findLocale = (attr?: ISkuOption) => {
        return attr?.translations?.find((el: any) => el.locale === props.locale)
    }

    const createMarkup = (item: string): any => {
        return {__html: item};
    };

    const skuName = findLocale(product?.sku_option[0])
    const description = findLocale(product?.description_option[0])
    const short_description = findLocale(product?.short_description_option[0])
    const shortDescr = createMarkup(replaceDescr(product?.product_flat[0]?.short_description))
    const descr = createMarkup(replaceDescr(product?.product_flat[0]?.description))

    const [defState, setDefState] = useState({
        quantity: 1,
        imagesData: null,
        simpleProduct: null,
        token,
        productSlug: props.productSlug,
        customer,
        wishlist,
        IsOpen: cls["product-inner-long-description-click"],
    });

    useEffect(() => {
        setProduct(props.productData)
        checkAddProd = true;
        setDefState({
            ...defState,
            // @ts-ignore
            product: props.productData,

            productSlug: props.productSlug,
            imagesData: props.productData.product_images,
        });
        // dispatch(AddImages(props.product.product_images));
        setProduct(props.productData)

        if (defState.token.cartToken === "") {
            ////////FIXME SHOW CHECK FROM STATE BEFORE FETCH
            // @ts-ignore
            fetch("/api/checkout/cart/token")
                .then((responce) => responce.json())
                .then((res) => {
                    if (res.api_token) {
                        dispatch(AddCartToken(res.api_token));
                    }
                })
                .catch((err) => console.error(err));
        }

    }, [props.change]);

    const handleChangeQuantity = (quantity: number): void => {
        setDefState({...defState, quantity});
    };
    const addToast = (product: any) => {
        //@ts-ignore
        toast.open(
            <span className="d-flex chek-fms">
                <CheckToastSvg/>
                <FormattedMessage
                    id="added_to_cart_toast"
                    defaultMessage={`Product "${product?.product_flat[0].name}" added to cart`}
                />
           </span>
        );
    }

    // checking is product in stock

    const isProductInStock = (product: { product_inventories: { qty: any; }[]; }) => {
        let qty = product?.product_inventories[0].qty
        return Number(qty) > 0 || (Number(qty) === 0 && backorders)
    }

    const addcart = product?.product_flat[0]?.has_up_sell == 0 && product?.product_flat[0]?.has_cross_sell == 0;
    const onlyCross = product?.product_flat[0]?.has_up_sell == 0 && product?.product_flat[0]?.has_cross_sell == 1;

    const openUpCrossProd = (product: { product_flat: { has_cross_sell: number; }[]; id: any; }) => {
        // @ts-ignore
        let hasUpSell = product?.product_flat[0]?.has_up_sell == 1;
        let hasCrossSell = product?.product_flat[0]?.has_cross_sell == 1;
        let page = true;

        if (!hasUpSell && hasCrossSell) {
            dispatch(getUpOrCrossProd(product.id, 'crossSell', props.locale, currencyCode, rate, page))
            dispatch(setPopupName("crossSell"));
        }
        if (hasUpSell) {
            dispatch(setPopupName("upsell"));
            dispatch(getUpOrCrossProd(product.id, 'upSell', props.locale, currencyCode, rate, page))
        }
    };

    const {layout = "standard", dbName, productSlug, domain} = props;
    const {quantity} = defState;
    const maxQty = bOrder ? 50000 : product?.product_inventories[0]?.qty;
    let addToCartDisabled = bOrder ? "" : "disabled";

    let componentsData = props?.getBuilderData?.[0]?.components || {};
    let tree = props?.getBuilderData?.[0]?.tree
    let initialLayout = props?.getBuilderData?.[0]?.initialLayout || {}
    const drawProducts = (product: any, title: string | JSX.Element, type: string) => {
        if (title === 'builder1') {
            {
                return <BuilderSection
                    tree={tree}
                    componentsData={componentsData}
                    tab={1}
                    initialLayout={initialLayout}
                    dbName={dbName}
                    domain={domain}
                />
            }
        } else if (title === 'builder2') {
            {
                return <BuilderSection
                    tree={tree}
                    componentsData={componentsData}
                    tab={2}
                    initialLayout={initialLayout}
                    dbName={dbName}
                    domain={domain}
                />
            }
        } else if (title === 'builder3') {
            {
                return <BuilderSection
                    tree={tree}
                    componentsData={componentsData}
                    tab={3}
                    initialLayout={initialLayout}
                    dbName={dbName}
                    domain={domain}
                />
            }
        }
    }
    let addAndRemoveWishList = () => {
        let wishlistChekArray = wishlist?.find((x) => {
            return x.id == product?.id;
        });

        if (wishlistChekArray == undefined) {
            //@ts-ignore
            toast.open(
                <span className="d-flex chek-fms">
                    <CheckToastSvg/>
                    <FormattedMessage
                        id="added_to_wishlist_toast"
                        defaultMessage={`Product "${product?.product_flat[0]?.name}" added to wish list`}
                    />
                </span>
            );
        } else {
            // @ts-ignore
            <AsyncAction
                // @ts-ignore
                action={dispatch(wishlistRemoveItem(product?.id))}
            />;
            //@ts-ignore
            toast.open(
                <span className="d-flex chek-fms">
                    <CheckToastSvg/>
                    <FormattedMessage
                        id="removed_from_wishlist_toast"
                        defaultMessage={`The product "${product?.product_flat[0]?.name}" was successfully removed from the whishlist`}
                    />
                </span>
            );
        }
    };
    const schemaProduct = {
        "@context": `${url}/${product?.product_flat[0]?.url_key}`,
        "@type": "Product",
        name: product?.product_flat[0]?.name,
        description: product?.product_flat[0]?.meta_description && product?.product_flat[0]?.description,
        image: `https://${dbName}/storage/${product?.product_images[0]?.path}`,
        brand: {
            "@type": "Brand",
            name: "Zega",
            logo: `${url}/storage/zega/configuration/logo/logo.webp`,
        },
        "review": {
            "@type": "Review",
            name: "Zega",
        },
        productID: product?.id,
        sku: product?.product_flat[0]?.sku,
    };

    // const addToCart = (
    //     <div
    //         className={classNames(`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]}`, {
    //             [cls["button_disabled"]]: !isProductInStock(product)
    //         })}
    //     >
    //         {
    //             addcart ?
    //                 (
    //                     <AsyncAction
    //                         // @ts-ignore
    //                         action={() => dispatch(cartAddItem(product, [], quantity, token, customer, props.locale,))}
    //
    //                         // @ts-ignore
    //                         render={({run, loading}) => (<button
    //                             type="button"
    //
    //                             onClick={() => {
    //                                 dispatch(setCrossValid(false));
    //                                 run();
    //                                 addToast(product)
    //                             }}
    //                             // @ts-ignore
    //                             // disabled={addToCartDisabled}
    //                             className={classNames(`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg btn-primary`, {
    //                                 "btn-loading": loading,
    //                             })}
    //                         >
    //                             <FormattedMessage
    //                                 id="add_to_cart"
    //                                 defaultMessage="Add to cart"
    //                             />
    //                         </button>)}
    //                     />
    //                 ) :
    //                 onlyCross ?
    //                     (
    //                         <AsyncAction
    //                             // @ts-ignore
    //                             action={() => dispatch(cartAddItem(product, [], quantity, token, customer, props.locale))}
    //                             // @ts-ignore
    //                             render={({run, loading}) => (<button
    //                                 type="button"
    //                                 onClick={() => {
    //                                     run();
    //                                     dispatch(setTempData([product]));
    //                                     dispatch(setPopup(true));
    //                                     dispatch(setCrossValid(true));
    //                                     openUpCrossProd(product);
    //                                     addToast(product)
    //                                 }}
    //                                 // @ts-ignore
    //                                 // disabled={addToCartDisabled}
    //                                 className={classNames(`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg`, {
    //                                     "btn-loading": loading,
    //                                 })}
    //                             >
    //                                 <FormattedMessage
    //                                     id="add_to_cart"
    //                                     defaultMessage="Add to cart"
    //                                 />
    //                             </button>)}
    //                         />
    //                     ) : (
    //                         <AsyncAction
    //                             // @ts-ignore
    //
    //                             render={({run, loading}) => (<button
    //                                 type="button"
    //
    //                                 onClick={() => {
    //                                     run();
    //                                     dispatch(setTempData([product]));
    //                                     dispatch(setPopup(true));
    //                                     dispatch(setCrossValid(false));
    //                                     openUpCrossProd(product);
    //                                 }}
    //                                 // @ts-ignore
    //                                 // disabled={addToCartDisabled}
    //                                 className={classNames(`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg`, {
    //                                     "btn-loading": loading,
    //                                 })}
    //                             >
    //                                 <FormattedMessage
    //                                     id="add_to_cart"
    //                                     defaultMessage="Add to cart"
    //                                 />
    //                             </button>)}
    //                         />
    //                     )}
    //     </div>
    // );

    const selectTab = (e: any) => {
        setIsSelectDetail(e.target.id === "detail")
    }

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{__html: JSON.stringify(schemaProduct)}}
                />
            </Head>

            <div>
                {drawProducts("builder1", "builder1", "builder")}
                <div className={cls["product__content"]}>

                    <ProductGallery
                        // @ts-ignore
                        layout={layout}
                        images={product?.product_images}
                        imageName={product?.product_flat[0]?.name}
                        locale={props.locale}
                    />

                    <div className={cls["product__info"]}>
                        {/*<div className={cls["product__wishlist-compare"]}>*/}
                        {/*    <AsyncAction*/}
                        {/*        // @ts-ignore*/}
                        {/*        action={() => wishlistAddItem(product, defState.locale)}*/}
                        {/*        // @ts-ignore*/}
                        {/*        render={({run, loading}) => (*/}
                        {/*            <button*/}
                        {/*                type="button"*/}
                        {/*                data-toggle="tooltip"*/}
                        {/*                data-placement="right"*/}
                        {/*                title="Wishlist"*/}
                        {/*                onClick={run}*/}
                        {/*                className={classNames("btn-sm btn-light btn-svg-icon", {*/}
                        {/*                    "btn-loading": loading,*/}
                        {/*                })}*/}
                        {/*            >*/}
                        {/*                <WishIcon product={product}/>*/}
                        {/*            </button>*/}
                        {/*        )}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        {/*<div className="product__rating"></div>*/}

                        <h1
                            style={{textAlign: "left"}}
                            className={cls["product__name"]}
                            dangerouslySetInnerHTML={createMarkup(product?.product_flat[0]?.name)}
                        />
                        {/*<p className="f14">{skuName ? skuName.name : "SKU"}: {product?.product_flat[0]?.sku}</p>*/}
                        {/*<Prices product={product}/>*/}
                        {/*<div>*/}
                        {/*    {product?.product_flat[0]?.price_html*/}
                        {/*        ? product?.product_flat[0]?.price_html.map((e: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined, i: React.Key | null | undefined) => (*/}
                        {/*            <span key={i} className={cls["product_price_html"]}>*/}
                        {/*                {e}*/}
                        {/*            </span>*/}
                        {/*        ))*/}
                        {/*        : ""}*/}
                        {/*</div>*/}
                        <div>
                            <div className={cls["product-inner-description-title"]}>
                                {short_description ? short_description.name : ""}
                            </div>
                            <div
                                style={{fontSize: "16px"}}
                                dangerouslySetInnerHTML={shortDescr}
                            />
                        </div>

                        {/*{!isMobile && <ul className={cls["product__meta"]}>*/}
                        {/*    <li className={cls["product__meta-availability"]}>*/}
                        {/*        <span*/}
                        {/*            className={*/}
                        {/*                isProductInStock(product) ? cls["text-success"] : cls["text-danger"]*/}
                        {/*            }*/}
                        {/*            style={{fontSize: "18px"}}*/}
                        {/*        >*/}
                        {/*            {isProductInStock(product) ? (*/}
                        {/*                <FormattedMessage id="in_stock" defaultMessage="In stock"/>*/}
                        {/*            ) : (*/}
                        {/*                <FormattedMessage*/}
                        {/*                    id="out_of_stock"*/}
                        {/*                    defaultMessage="Not available"*/}
                        {/*                />*/}
                        {/*            )}{" "}*/}
                        {/*        </span>*/}
                        {/*    </li>*/}
                        {/*</ul>}*/}

                        {/*    ///  */}
                        {!isMobile ? (
                            <div className={cls["product__sidebar"]}>
                                <form className={cls["product__options"]}>
                                    <div className={`form-group ${cls["product__option"]}`}>
                                        <div className={cls["product__actions"]}>
                                            {/*<div*/}
                                            {/*    className={`${cls["product__actions-item"]} ${cls["product-inner-quantity"]}`}>*/}
                                            {/*    <InputNumber*/}
                                            {/*        // @ts-ignore*/}
                                            {/*        id="product-quantity"*/}
                                            {/*        aria-label="Quantity"*/}
                                            {/*        className={cls["product__quantity"]}*/}
                                            {/*        size="lg"*/}
                                            {/*        min={1}*/}
                                            {/*        max={maxQty}*/}
                                            {/*        value={quantity}*/}
                                            {/*        onChange={handleChangeQuantity}*/}
                                            {/*        // disabled={addToCartDisabled}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            {/*{hasPhoneNumber && */}
                                            <div
                                                className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]} `}>

                                                <Link
                                                    href={`tel:${phoneNumber?.includes("+")? phoneNumber : "+" + phoneNumber}`}
                                                >
                                                    <a className={`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg btn-primary`}>
                                                        <FormattedMessage
                                                            id="booking_now_service_theme"
                                                            defaultMessage="Booking now"
                                                        />
                                                    </a>
                                                </Link>
                                            </div>
                                            {/*}*/}
                                            {/*{signed ? (*/}
                                            {/*    <div*/}
                                            {/*        className={`${cls["product__actions-item"]} ${cls["product__actions-item--wishlist"]} ${cls["liked-button-wrapper"]}`}*/}
                                            {/*    >*/}
                                            {/*        <span onClick={addAndRemoveWishList}>*/}
                                            {/*            <AsyncAction*/}
                                            {/*                // @ts-ignore*/}
                                            {/*                action={() =>*/}
                                            {/*                    dispatch(*/}
                                            {/*                        // @ts-ignore*/}
                                            {/*                        wishlistAddItem(product, defState.locale)*/}
                                            {/*                    )*/}
                                            {/*                }*/}
                                            {/*                // @ts-ignore*/}
                                            {/*                render={({run, loading}) => (*/}
                                            {/*                    <button*/}
                                            {/*                        type="button"*/}
                                            {/*                        data-toggle="tooltip"*/}
                                            {/*                        title="Wishlist"*/}
                                            {/*                        onClick={run}*/}
                                            {/*                        className={classNames("btn-light btn-svg-icon btn-svg-icon--fake-svg", {*/}
                                            {/*                            "btn-loading": loading,*/}
                                            {/*                        })}*/}
                                            {/*                    >*/}
                                            {/*                        <WishIcon product={product}/>*/}
                                            {/*                    </button>*/}
                                            {/*                )}*/}
                                            {/*            />*/}
                                            {/*        </span>*/}
                                            {/*    </div>*/}
                                            {/*) : (*/}
                                            {/*    <div className={cls["liked-button-wrapper"]}>*/}

                                            {/*        <button*/}
                                            {/*            type="button"*/}
                                            {/*            onClick={(e) => {*/}
                                            {/*                e.preventDefault();*/}
                                            {/*                //@ts-ignore*/}
                                            {/*                toast.open(*/}
                                            {/*                    <span className="d-flex faild-toast-fms">*/}
                                            {/*                <FailSvg/>*/}
                                            {/*                <FormattedMessage*/}
                                            {/*                    id="please_signin_toast"*/}
                                            {/*                    defaultMessage="Please sign in or register"*/}
                                            {/*                />*/}
                                            {/*            </span>*/}
                                            {/*                );*/}
                                            {/*            }}*/}
                                            {/*            className={`btn-light btn-svg-icon btn-svg-icon--fake-svg ${cls["product-card__wishlist"]}`}*/}
                                            {/*        >*/}
                                            {/*            <WishIcon product={product}/>*/}
                                            {/*        </button>*/}
                                            {/*    </div>*/}

                                            {/*)}*/}

                                            {/*<div*/}
                                            {/*    className={`${cls["product__actions-item"]} ${cls["product__actions-item--compare"]}`}>*/}
                                            {/*</div>*/}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        ) : (
                            <div>
                                {/*<div>*/}
                                {/*    <ul className={cls["product__meta"]}>*/}
                                {/*        <li className={cls["product__meta-availability"]}>*/}
                                {/*        <span*/}
                                {/*            className={*/}
                                {/*                isProductInStock(product) ? cls["text-success"] : cls["text-danger"]*/}
                                {/*            }*/}
                                {/*            style={{fontSize: "18px"}}*/}
                                {/*        >*/}
                                {/*            {isProductInStock(product) ? (*/}
                                {/*                <FormattedMessage id="in_stock" defaultMessage="In stock"/>*/}
                                {/*            ) : (*/}
                                {/*                <FormattedMessage*/}
                                {/*                    id="out_of_stock"*/}
                                {/*                    defaultMessage="Not available"*/}
                                {/*                />*/}
                                {/*            )}{" "}*/}
                                {/*        </span>*/}
                                {/*        </li>*/}
                                {/*        <div*/}
                                {/*            className={`${cls["product__actions-item"]} ${cls["product-inner-quantity"]}`}>*/}
                                {/*            <InputNumber*/}
                                {/*                // @ts-ignore*/}
                                {/*                id="product-quantity"*/}
                                {/*                aria-label="Quantity"*/}
                                {/*                className={cls["product__quantity"]}*/}
                                {/*                size="lg"*/}
                                {/*                min={1}*/}
                                {/*                max={maxQty}*/}
                                {/*                value={quantity}*/}
                                {/*                onChange={handleChangeQuantity}*/}
                                {/*                // disabled={addToCartDisabled}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*    </ul>*/}
                                {/*</div>*/}
                                <div>
                                    <form className={cls["product__options"]}>
                                        <div className={`form-group ${cls["product__option"]}`}>
                                            <div className={cls["product__actions"]}
                                                 style={{display: "flex", justifyContent: "space-between"}}
                                            >
                                                {/*{signed ? (*/}
                                                {/*    <div*/}
                                                {/*        className={`*/}
                                                {/*    ${cls["product__actions-item "]}*/}
                                                {/*    ${cls["product__actions-item--wishlist "]}*/}
                                                {/*    ${cls["liked-button-wrapper"]}`}>*/}
                                                {/*        <span onClick={addAndRemoveWishList}>*/}
                                                {/*            <AsyncAction*/}
                                                {/*                // @ts-ignore*/}
                                                {/*                action={() =>*/}
                                                {/*                    dispatch(*/}
                                                {/*                        // @ts-ignore*/}
                                                {/*                        wishlistAddItem(product, defState.locale)*/}
                                                {/*                    )*/}
                                                {/*                }*/}
                                                {/*                // @ts-ignore*/}
                                                {/*                render={({run, loading}) => (*/}
                                                {/*                    <button*/}
                                                {/*                        type="button"*/}
                                                {/*                        data-toggle="tooltip"*/}
                                                {/*                        title="Wishlist"*/}
                                                {/*                        onClick={run}*/}
                                                {/*                        className={classNames("btn-light btn-svg-icon btn-svg-icon--fake-svg", {*/}
                                                {/*                            "btn-loading": loading,*/}
                                                {/*                        })}*/}
                                                {/*                    >*/}
                                                {/*                        <WishIcon product={product}/>*/}
                                                {/*                    </button>*/}
                                                {/*                )}*/}
                                                {/*            />*/}
                                                {/*        </span>*/}
                                                {/*    </div>*/}
                                                {/*) : (*/}
                                                {/*    <div className={cls["liked-button-wrapper"]}>*/}

                                                {/*        <button*/}
                                                {/*            type="button"*/}
                                                {/*            onClick={(e) => {*/}
                                                {/*                e.preventDefault();*/}
                                                {/*                //@ts-ignore*/}
                                                {/*                toast.open(*/}
                                                {/*                    <span className="d-flex faild-toast-fms">*/}
                                                {/*                    <FailSvg/>*/}
                                                {/*                    <FormattedMessage*/}
                                                {/*                        id="please_signin_toast"*/}
                                                {/*                        defaultMessage="Please sign in or register"*/}
                                                {/*                    />*/}
                                                {/*                </span>*/}
                                                {/*                );*/}
                                                {/*            }}*/}
                                                {/*            className="btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist"*/}
                                                {/*        >*/}
                                                {/*            <WishIcon product={product}/>*/}
                                                {/*        </button>*/}
                                                {/*    </div>*/}

                                                {/*)}*/}
                                                {/*{hasPhoneNumber && */}
                                                    <div
                                                    className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]} `}>

                                                    <Link
                                                        href={`tel:${phoneNumber?.includes("+") ? phoneNumber : "+" + phoneNumber}`}
                                                    >
                                                        <a className={`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg btn-primary`}>
                                                            <FormattedMessage
                                                                id="booking_now_service_theme"
                                                                defaultMessage="Booking now"
                                                            />
                                                        </a>
                                                    </Link>
                                                </div>
                                                {/*}*/}
                                                {/*<div className="product__actions-item product__actions-item--compare"></div>*/}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                        <div className={cls["socialLinksBox"]}>
                            <SMSharedButton
                                url={`https://${dbName}/products/${productSlug}`}
                            />
                        </div>
                    </div>

                </div>

                {drawProducts("builder2", "builder2", "builder")}
                <div className={`${cls["tab_buttons"]} ${!checkDetail(details) && cls["only_one"]} `}>
                    <div
                        className={isSelectDetail ? `${cls["tab"]} ${cls["tab_description"]}` : `${cls["tab"]} ${cls["tab_description"]} ${cls["tab_description-active"]}`}>
                        <div className={`${cls["product-inner-description-title"]}`} onClick={selectTab}>
                            {description?.name || ""}
                        </div>
                    </div>
                    {
                        checkDetail(details) &&
                        <div
                            className={isSelectDetail ? `${cls["tab"]} ${cls["tab_detail"]} ${cls["tab_detail-active"]}` : `${cls["tab"]} ${cls["tab_detail"]}`}>
                            <div className={cls["product-inner-description-title"]} id="detail" onClick={selectTab}>
                                <FormattedMessage id="details" defaultMessage="details"/>
                            </div>
                        </div>
                    }
                </div>
                {
                    isSelectDetail
                        ? <Details details={details}/>
                        :
                        <div className={cls["product-inner-long-description"]}>
                            <div style={{paddingLeft: "30px"}}>
                                <div
                                    dangerouslySetInnerHTML={descr}
                                />
                            </div>
                        </div>
                }
                {drawProducts("builder3", "builder3", "builder")}

            </div>
        </>
    );
};

export default SimpleProduct;